import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IconMessages } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { TOGGLE_ASSIST_PANEL, selectOpenChats } from '@/reducers/realtime/realtimeChats.redux'

import './AgentAssistLauncher.scss'

/**
 * Permanent navbar launcher for the Agent Assist coaching panel. The badge
 * counts the manager's open agent chats so the workspace is reachable at a
 * glance, not only via a transient notification. Opening is a plain toggle —
 * the panel is fixed bottom-right, independent of the sidebar, so there's no
 * collapse-and-anchor dance like the notification bell.
 */
export const AgentAssistLauncher = ({ collapsed = false }) => {
  const dispatch = useDispatch()
  const { panelOpen, chats } = useSelector((state) => state.realtimeChats)

  const chatCount = selectOpenChats(chats).length
  const ariaLabel = chatCount > 0 ? `Agent Assist (${chatCount} active)` : 'Agent Assist'

  return (
    <div className="agent-assist-launcher">
      <Button
        basic
        small
        square
        active={panelOpen}
        onClick={() => dispatch({ type: TOGGLE_ASSIST_PANEL })}
        data-testid="agent-assist-launcher"
        aria-label={ariaLabel}
        tooltip="Agent Assist"
        tooltipProps={{ placement: collapsed ? 'right' : 'top' }}
      >
        <IconMessages size={20} />
        {chatCount > 0 && (
          <span className="agent-assist-launcher__badge" data-testid="agent-assist-badge">
            {chatCount > 99 ? '99+' : chatCount}
          </span>
        )}
      </Button>
    </div>
  )
}
